import thunk from "redux-thunk";
import { createHashHistory } from "history";
import storage from "redux-persist/lib/storage"; // defaults to localStorage for web and AsyncStorage for react-native

import { createStore, applyMiddleware, compose } from "redux";
import { routerMiddleware } from "connected-react-router";
import { persistStore, persistReducer } from "redux-persist";

import getAppReducers from "services/reducer";
import VisitorCharacteristicsMiddleware from "services/visitorCharacteristics/middleware";
import CustomAnalysisMiddleware from "services/customAnalysis/middleware";
import GlobalFiltersMiddleware from "services/globalFilters/middleware";
import IndicatorsMiddleware from "services/indicators/middleware";

const composeEnhancers =
  typeof window === "object" && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
    ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({
        name: "parkki-client-backoffice",
        trace: true,
      })
    : compose;

const routerHistory = createHashHistory();
const routeMiddleware = routerMiddleware(routerHistory);

const persistedReducer = persistReducer(
  {
    key: "parkki-client-backoffice",
    storage,
    whitelist: [
      "Authentication",
      "User",
      "Contract",
      "GlobalFilters",
      "ParkStatistics",
      "NonMovingCars",
      "Flow",
      "CustomAnalysis",
      "Indicators",
      "Live",
      "AlertFactory",
      "AutomaticSystems",
    ],
  },
  getAppReducers(routerHistory)
);

const enhancer = composeEnhancers(
  applyMiddleware(
    thunk,
    routeMiddleware,
    GlobalFiltersMiddleware,
    CustomAnalysisMiddleware,
    VisitorCharacteristicsMiddleware,
    IndicatorsMiddleware
  )
);
const applicationStore = createStore(persistedReducer, enhancer);
const persistor = persistStore(applicationStore);

export { applicationStore, persistor, routerHistory };
